export default class LinkCursor {
    constructor(element, parent = null) {
        if (!element) return;

        this.element = element;
        this.parent = parent;

        this.init();
    }

    init() {
        this.registerEvents();
    }

    registerEvents() {
        if (this.parent !== null) {
            this.element.closest('.pane').addEventListener('mouseover', this.toggleIcon.bind(this));
            this.element.closest('.pane').addEventListener('mouseout', this.toggleIcon.bind(this));
            this.element.closest('.pane').addEventListener('mousemove', this.moveIcon.bind(this));
        } else {
            this.element.addEventListener('mouseover', this.toggleIcon.bind(this));
            this.element.addEventListener('mouseout', this.toggleIcon.bind(this));
            this.element.addEventListener('mousemove', this.moveIcon.bind(this));
        }
    }

    toggleIcon() {
        if (this.parent !== null) {
            this.element.closest('.pane').querySelector('.pane__icon').classList.toggle('is-showing');
        } else {
            this.element.querySelector('.pane__icon').classList.toggle('is-showing');
        }
    }

    moveIcon(event) {
        let container = event.target;

        if (this.parent !== null) {
            container = event.target.closest('.pane');
        }

        const icon = container.querySelector('.pane__icon');
        const rect = container.getBoundingClientRect();

        const clientX = event.clientX - rect.left; // X coordinate relative to the container
        const clientY = event.clientY - rect.top;

        icon.style.top = `${clientY}px`;
        icon.style.left = `${clientX}px`;
    }
}
